module.exports = __webpack_public_path__ + "static/media/about1.c9d9562f.png";